import { Popover } from '@medly-components/core';
import { useContext, type FC } from 'react';
import { ClearButtonStyled } from './ClearButton.styled';

export const ClearButton: FC<{ onClick: () => void }> = ({ onClick }) => {
    const [, setCalenderVisibility] = useContext(Popover.Context);

    const handleOnChange = () => {
        onClick();
        setCalenderVisibility(false);
    };
    return <ClearButtonStyled onClick={handleOnChange}>Clear</ClearButtonStyled>;
};

ClearButton.displayName = 'ClearButton';
